module.exports = __webpack_public_path__ + "static/media/pusins_bonfe_delama.80b7c1cb.gif";